<script lang="tsx">
/* eslint-disable no-nested-ternary */
  import { PropType, defineComponent } from 'vue'
  import { BeerStyleObj, ModifierColor } from '@xhs/yam-beer/core'
  import { HINT_ICON } from '@xhs/yam-beer/cmp/constants/builtinIcon'
  import NewBsBox from '../../primitive/NewBsBox'
  import RedIconsPath from './generated/iconSvgPaths'
  import initStyle from './style'

  initStyle()

  export default defineComponent({
    name: 'BeerIcon',
    props: {
      /**
       * 图标的名称
       */
      icon: {
        required: false,
        type: [String, Array] as PropType<string|string[]>,
        default: undefined,
      },
      /**
       * @ignore
       * svg path
       */
      iconPath: {
        required: false,
        type: Array as PropType<string[]>,
        default: undefined,
      },
      /**
       * 图标的颜色
       * @type {body|primary|secondary|danger|success}
       */
      color: {
        type: String as PropType<ModifierColor>,
        default: 'body',
      },
      /**
       * 图标的大小
       * @type {16|20|40}
       * @see style
       */
      size: {
        type: [String, Number] as PropType<string|number>,
        default: 16,
      },
      /**
       * viewBox属性允许指定一个给定的一组图形伸展以适应特定的容器元素。
       * @see https://developer.mozilla.org/zh-CN/docs/Web/SVG/Attribute/viewBox
       */
      viewBox: {
        type: String as PropType<string>,
        required: false,
        default: undefined,
      },
      /**
       * viewBox的width和height 默认min-x和min-y为0如需自定义请使用viewBox
       */
      gridSize: {
        type: Number as PropType<number>,
        default: 24,
      },
      /**
       * @ignore
       * 语义化角色
       */
      role: {
        type: String as PropType<string>,
        default: 'img',
      },
      /**
       * @ignore
       * 是否以evenodd规则填充
       */
      evenOdd: {
        type: Boolean as PropType<boolean>,
        default: true,
      },
      /**
       * @ignore
       */
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * 是否内联在文字中，影响 图标和它周围内容的对齐方式
       */
      textInline: {
        type: Boolean as PropType<boolean>,
        default: true,
      },
    },
    render() {
      const {
        icon,
        iconPath,
        viewBox,
        gridSize,
        evenOdd,
        color,
        bs,
        size,
        role,
        textInline,
      } = this.$props
      const pasedViewBox = viewBox || `0 0 ${gridSize} ${gridSize}`
      let svgPaths : string[] = iconPath || []
      if (icon && svgPaths.length < 1) {
        if (Array.isArray(icon)) {
          svgPaths = icon
        } else {
          // @ts-ignore
          svgPaths = HINT_ICON[icon] || RedIconsPath[icon] || [icon]
        }
      }
      const mergedBs = {
        size: typeof size === 'string'
          ? (size.endsWith('px') ? size : `${size}px`)
          : size,
        fill: color as string,
        verticalAlign: textInline ? 'text-bottom' : 'inherit',
        ...bs,
      }

      return (
        <NewBsBox
          {...{
            ...this.$attrs,
            viewBox: pasedViewBox,
            role,
            as: 'svg',
            bs: mergedBs,
          }}>
          {svgPaths.map((i, index) => (
            <path
              key={index}
              d={i}
              clip-rule={evenOdd ? 'evenodd' : undefined}
              fill-rule={evenOdd ? 'evenodd' : undefined} />
          ))}
        </NewBsBox>
      )
    },
  })
</script>
